// ============================================
// Path: /frontend/src/components/ui/skeleton.jsx
// Purpose: Skeleton loading placeholder component
// ============================================

import { cn } from "../../lib/utils";

function Skeleton({ className, ...props }) {
  console.log('🎨 [Skeleton] Rendering skeleton placeholder');
  
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  );
}

export { Skeleton };